import { useLDClient } from "launchdarkly-react-client-sdk";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import IVenue from "../interfaces/IVenue";
import { IReduxAppState } from "../reducers";

export const useSetLaunchDarklyUser = () => {
    const ldClient = useLDClient();
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venue = useSelector((state: IReduxAppState) => state.venue[venueId]);

    const setLaunchDarklyUser = useCallback(() => {
        if(!venue || !venue.venueData || !venue.venueLocation) return;
        const { venueData, venueLocation } = venue;
        const { id, onboarding_source, venue_nickname, payment_processor } = venueData as IVenue;
        const { address_country } = venueLocation as ILocationAPIObject;
        const custom = {
            ...onboarding_source && {onboardingSource: onboarding_source}, 
            ...venue_nickname && {venueNickname: venue_nickname}, 
            ...address_country && {venueCountry: address_country},
            ...payment_processor && {paymentProcessor: payment_processor}
        };
        if (venue) {
            ldClient?.identify({ 
                key: id, 
                custom
            });
        }        
    }, [ldClient, venue]);

    useEffect(() => {
        if(venue?.venueData && venue?.venueLocation){
            setLaunchDarklyUser();
        };
    }, [venue?.venueData, venue?.venueLocation, setLaunchDarklyUser]);
}